export const IsUpdatedAiCredit = (v) => v.aiCredit !== undefined &&
    v.updateSerial !== undefined &&
    typeof v.aiCredit === 'number' &&
    typeof v.updateSerial === 'string';
